module.exports = [{
      plugin: require('/home/runner/work/hawaiiana-management-company-website/hawaiiana-management-company-website/node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-155291885-1","head":true},
    },{
      plugin: require('/home/runner/work/hawaiiana-management-company-website/hawaiiana-management-company-website/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
